import { SAVE_FILTER } from './types';

export const saveFilter = (filteredFields, filterType) => (dispatch) => {
    dispatch({
        type: SAVE_FILTER,
        payload: { filteredFields, filterType },
    });
};
